import 'core-js/modules/web.dom-collections.iterator.js';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import { TextEncoder, TextDecoder } from 'text-encoding-shim';
import 'core-js/modules/es.array-buffer.slice.js';
import 'core-js/modules/es.typed-array.uint8-array.js';
import 'core-js/modules/es.typed-array.fill.js';
import 'core-js/modules/es.typed-array.set.js';
import 'core-js/modules/es.typed-array.sort.js';
import 'core-js/modules/es.typed-array.to-locale-string.js';

const encoder = new TextEncoder();
/**
 * Encodes a string into base64 format.
 *
 * @param str - The string to be base64 encoded
 * @returns An ASCII string containing the Base64 representation of the string
 *
 * @example
 * ```javascript
 * import { base64Encode } from '@thisisbud/base64-utils'
 *
 * const output = base64Encode('foobar'})
 * // Zm9vYmFy
 * ```
 */

function base64Encode(str) {
  var _context;

  const encoded = _mapInstanceProperty(_context = [...encoder.encode(str)]).call(_context, function (charCode) {
    return String.fromCharCode(charCode);
  }).join('');

  return btoa(encoded);
}

const decoder = new TextDecoder();
/**
 * Decodes a string from base64 format.
 *
 * @param str - The string to be decoded from base64
 * @returns An ASCII string containing decoded data from the string
 *
 * @example
 * ```javascript
 * import { base64Decode } from '@thisisbud/base64-utils'
 *
 * const output = base64Decode('Zm9vYmFy'})
 * // foobar
 * ```
 */

function base64Decode(str) {
  var _context;

  const encodedStr = atob(str);
  return decoder.decode(_mapInstanceProperty(_context = new Uint8Array(encodedStr.length)).call(_context, function (element, index) {
    return encodedStr.charCodeAt(index);
  }));
}

export { base64Decode, base64Encode };
